import { render, staticRenderFns } from "./ConditionRegistrationIframe.vue?vue&type=template&id=e6ea35fe&"
import script from "./ConditionRegistrationIframe.vue?vue&type=script&lang=ts&"
export * from "./ConditionRegistrationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports